import React from 'react';

import { Typo as VideoContentInformationText } from 'uikit/content';

import { LearningObjectivesLearnerList } from '@/courseOutline';
import { getSanitizedDescription, EnrollmentMessage } from '@/exceed';

import VideoContentInformationMeta from './videoContentInformationMeta';
import VideoContentActions from './videoContentActions';
import VideoContentRatingActions from './videoContentRatingActions';

import styles from '../styles/videoContentInformation.module.scss';

/* eslint-disable camelcase */
const VideoContentInformation = ({
  title,
  description,
  dropEnrollment,
  reportVideo,
  published_at,
  duration,
  difficulty,
  author,
  isEnrolled,
  is_favorited,
  vote_total,
  vote_user,
  favouriteVideo,
  unfavouriteVideo,
  updateReview,
  type,
  learning_objectives,
  display_learning_objectives,
  enrollmentData,
}) => (
  <>
    <EnrollmentMessage courseType="Video" enrollmentMetadata={enrollmentData} />
    <VideoContentInformationText className={styles.title} element="h1" variant="h2" modifier="bold">
      {title}
    </VideoContentInformationText>
    <VideoContentInformationMeta
      author={author}
      published_at={published_at}
      duration={duration}
      difficulty={difficulty}
      vote_total={vote_total}
      type={type}
    />
    <VideoContentActions
      dropEnrollment={dropEnrollment}
      reportVideo={reportVideo}
      is_favorited={is_favorited}
      favouriteVideo={favouriteVideo}
      unfavouriteVideo={unfavouriteVideo}
      title={title}
      is_enrolled={isEnrolled}
    />
    <div
      className={styles.description}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: getSanitizedDescription({ html: description }),
      }}
    />
    {learning_objectives && learning_objectives.length > 0 && display_learning_objectives && (
      <LearningObjectivesLearnerList
        className={styles.learningObjectives}
        title={title}
        learningObjectives={learning_objectives}
      />
    )}
    {vote_user !== undefined && type !== 'live' && (
      <VideoContentRatingActions
        currentVote={vote_user}
        handleVote={updateReview.mutate}
        isLoading={updateReview.isLoading}
      />
    )}
  </>
);

VideoContentInformation.defaultProps = {};

VideoContentInformation.propTypes = {};

export default React.memo(VideoContentInformation);
